import React, { FC, useEffect } from 'react';
import { useMatch } from '@reach/router';
import {withPrefix} from "gatsby-link";

const FreshChatWrapper: FC = ({ children }) => {
  const matched = useMatch('/');

  const showFreshChat = () => {
    window.fcWidget?.show();
  };
  const hideFreshChat = () => {
    window.fcWidget?.close();
    window.fcWidget?.hide();
  };

  useEffect(() => {
    console.log('test use effect - matched ', matched);
    console.log('test use effect - prefix  ', withPrefix(""));

    if (matched) {
      showFreshChat();
      return hideFreshChat;
    }
  }, [matched]);

  return <div>{children}</div>;
};

export default FreshChatWrapper;
